<div class="full-height">
  @if (!isTestStarted && !isTestExampleStarted && !isTestOver && booking) {
    <onset-cloze-test-introduction
      [title]="startPageTitle"
      [subtitle]="startPageSubtitle"
      [totalExercise]="$any(booking?.numAufgaben)"
      [currentExerciseNumber]="currentExercise"
      [content]="startPageContent"
      [clozeTestStyleModel]="clozeTestStyleModel()"
      [cTestLogo]="cTestLogo"
      [cTestButtonColor]="cTestButtonColor"
      [mobileMode]="mobileMode()"
      (startTest)="onStartTest($event)"
      (startTestExample)="onStartTestExample()">
    </onset-cloze-test-introduction>
 }

  @if (!isTestStarted && isTestExampleStarted && booking) {
      <onset-cloze-test-exercise-example
        [clozeTestStyleModel]="clozeTestStyleModel()"
        [cTestLogo]="cTestLogo"
        [lang]="lang()"
        [cTestButtonColor]="cTestButtonColor"
        (startTest)="onStartTest($event)">
      </onset-cloze-test-exercise-example>
}

  @if (isTestStarted && !isTestOver) {
<onset-cloze-test-exercise
  [title]="exerciseTitle"
  [content]="exerciseContent"
  [isLastExercise]="isLastExercise"
  [currentExcerciseNumber]="currentExercise"
  [lastExerciseNumber]="lastExcercise"
  [totalExercise]="$any(booking?.numAufgaben)"
  [clozeTestStyleModel]="clozeTestStyleModel()"
  [bookingId]="booking.buchungId"
  [exerciseId]="exerciseId"
  [cTestLogo]="cTestLogo"
  [cTestButtonColor]="cTestButtonColor"
  [mobileMode]="mobileMode()"
  [clozeTestModel]="clozeTestModel()"
  (nextExercise)="onNextExercise($event)"
  (endTest)="onTestEnd($event)"></onset-cloze-test-exercise>
  }

@if (isTestOver && !showGerInfo) {
    <onset-cloze-test-result
      [results]="results()"
      [showResult]="showResult()"
      [clozeTestStyleModel]="clozeTestStyleModel()"
      [totalExercise]="$any(booking?.numAufgaben)"
      [currentExerciseNumber]="currentExercise"
      [cTestLogo]="cTestLogo"
      [cTestButtonColor]="cTestButtonColor"
      [mobileMode]="mobileMode()"
      [showEndTestButton]="showEndTestButton()"
      [showGer]="showGer()"
      [showCustomButton]="showCustomButton()"
      [customButtonIcon]="customButtonIcon()"
      [customButtonIconHeight]="customButtonIconHeight()"
      [customButtonText]="customButtonText()"
      [customResultLevelText]="customResultLevelText()"
      (customButton)="onCustomButton()"
      (clozeTest)="onClozeTest($event)"
      (gerInfo)="onGerInfoClick()">
    </onset-cloze-test-result>
  }

  @if (isTestOver && showGerInfo && !gerInfoNewTab()) {
    <onset-cloze-test-ger-info
      [clozeTestStyleModel]="clozeTestStyleModel()"
      [cTestLogo]="cTestLogo"
      [cTestButtonColor]="cTestButtonColor"
      [mobileMode]="mobileMode()"></onset-cloze-test-ger-info>
  }
</div>
